module.exports = __webpack_public_path__ + "static/standalone/img/collection-invoice.71891414.svg";